<template>
  <div>
    <div class="select_color">
      <p
        :class="['select_color_item black', {active: isBlackImage}]"
        @click="changeBlackColor"
      />
      <p
        :class="['select_color_item white border_white', {active: !isBlackImage}]"
        @click="changeWhiteColor"
      />
    </div>
    <div id="device">
      <div
        id="device_bg"
        :class="[isBlackImage ? 'is_black' : 'is_white']"
      />
      <div id="sp_wrapper">
        <iframe
          :src="url"
          name="sp_preview"
          width="345"
          height="696"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      isBlackImage: true
    };
  },
  methods: {
    changeBlackColor() {
      this.isBlackImage = true;
    },
    changeWhiteColor() {
      this.isBlackImage = false;
    }
  }
};
</script>

<style lang="scss" scoped>
  #device {
    position:relative;
    width: 375px;
    height: 773px;
    margin: 30px auto 100px;
  }
  #device_bg {
    width: 375px;
    height: 773px;
    position: absolute;
    z-index: 3;
    pointer-events: none;
    box-shadow: 0 0 10px 10px #ededed;
    border-radius: 48px;
  }
  .is_black {
    background-image: url(/static/image/release/iphone_bk.svg);
    background-repeat: no-repeat;
  }
  .is_white {
    background-image: url(/static/image/release/iphone_wh.svg);
    background-repeat: no-repeat;
  }
  #sp_wrapper {
    height: 696px;
    width: 345px;
    margin-left: 15px;
    position: absolute;
    top: 64px;
  }
  .select_color {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f7f7f7;
  }
  .select_color_item {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 15px;
    cursor: pointer;
  }
  .black {
    background-color: #474646;
  }
  .white {
    background-color: #fff;
  }
  .border_white {
    border: 1px solid #c1c1c1;
  }
  .select_color_item.active {
    border: 3px solid #29ad4b;
  }
</style>
